<!--  -->
<template>
  <div>
    <!-- header 导航栏 -->
    <div class="nav">
      <div
        style="
          width: 233px;
          height: 80px;

          display: flex;
          flex-direction: column;
          justify-content: center;
        "
      >
        <img
          src="../assets/首页_slices/logo.png"
          alt=""
          style="width: 180px; height: 40px"
        />

        <!-- <div
          style="
            margin-left: 10px;
            font-weight: 400;
            color: #fff;
            font-size: 20px;
          "
        >
          博爱医药
        </div> -->
      </div>
      <div>
        <ul class="center">
          <li @click="btnClick(1)">
            <a :class="{ active: itemIndex == 1 }">首页</a> |
          </li>
          <li>
            <a :class="{ active: itemIndex == 2 }" @click="btnClick(2)"
              >会社情報</a
            >
            |
          </li>
          <li @click="btnClick(3)">
            <a :class="{ active: itemIndex == 3 }">事業内容</a> |
          </li>
          <li @click="btnClick(4)">
            <a :class="{ active: itemIndex == 4 }">採用情報</a> |
          </li>
          <li @click="btnClick(5)">
            <a :class="{ active: itemIndex == 5 }">お問い合わせ</a>
          </li>
          <!-- <li @click="btnClick(4)">
          <a :class="{ active: itemIndex == 4 }">博爱大事记</a>|
        </li>
        <li @click="btnClick(5)">
          <a :class="{ active: itemIndex == 5 }">供应商平台</a>|
        </li>
        <li @click="btnClick(6)">
          <a :class="{ active: itemIndex == 6 }">人才招聘</a>|
        </li> -->

          <!-- <li>
          <a href="#"
            ><img
              src="../assets/web/sousuo.png"
              alt=""
              style="width: 12px; height: 12px; margin-left: 10px"
          /></a>
        </li> -->
          <!-- <li>
          <a href="#"
            ><img
              src="../assets/web/phone.png"
              alt=""
              style="width: 12px; height: 12px"
            />&nbsp;&nbsp;&nbsp; 0417-5675777</a
          >
        </li> -->
        </ul>
      </div>
    </div>
    <!-- 1是首页  2是关于我们 3是会员服务 4是博爱大事记 5是供应商平台 6是人才招聘-->
    <div v-if="this.itemIndex == 1">
      <!-- banner -->
      <div class="top-rowBanner"></div>

      <!-- 会社案内 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding: 100px 0;
        "
      >
        <!-- left -->
        <div
          style="
            width: 1200px;
            height: 259px;
            display: flex;
            justify-content:space-between
          
            border:1px solid red
          "
        >
          <!-- right -->
          <div>
            <div>
              <img
                src="../assets/首页_slices/会社案内.png"
                alt=""
                style="width: 115px; height: 27px"
              />
              <img
                src="../assets/首页_slices/Company Profile.png"
                alt=""
                style="margin-left: 20px; height: 13px"
              />
            </div>
            <div style="margin-top: 20px"><B>____</B></div>
            <div>
              <img
                src="../assets/首页_slices/株式会社政軒は、アジア圏を中心に日本製の商品の輸出販売業を行っております。 各国の取引先からいただく「メイドインジャパン」商品.png"
                alt=""
                style="margin-top: 40px; height: 125px; width: 500px"
              />
            </div>
          </div>
          <!-- left -->
          <div>
            <img
              src="../assets/首页_slices/图层 15.png"
              alt=""
              style="width: 400px; height: 500px"
            />
          </div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          height: 100px;
          background: #eef2f6;
          margin-top: 39.6px;
          border-top: 1px solid #eef2f6;
          display: flex;
          align-items: center;
        "
      >
        <img
          src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
          alt=""
          style="margin-left: 336px; height: 18px"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1200px;
          "
        >
          <div
            style="
              width: 1200px;
              display: flex;
              justify-content: center;
              align-items:end
              color: #0762cb;

            margin-top:100px
            "
          >
            <img
              src="../assets/首页_slices/中国本社.png"
              alt=""
              style="width: 115px; height: 27px"
            />
            <img
              src="../assets/首页_slices/China Head Office.png"
              alt=""
              style="width: 130px; height: 13px; margin-left: 20px"
            />
          </div>
        </div>
        <div style="margin-top: 20px"><B>____</B></div>

        <div
          style="
            width: 1200px;
            height: 259px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 45px;
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/首页_slices/图层 20.png"
            alt=""
            style="width: 387px; height: 240px"
          />
          <img
            src="../assets/首页_slices/图层 22.png"
            alt=""
            style="width: 387px; height: 240px"
          />
          <img
            src="../assets/首页_slices/图层 23.png"
            alt=""
            style="width: 387px; height: 240px"
          />
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <!-- <div style="margin-top:20px"><B>____</B></div> -->

        <div
          style="
            width: 1200px;

            display: flex;

            align-items: center;
            margin-top: 245px;
            position: relative;
          "
        >
          <!-- right -->
          <div style="display: flex; flex-direction: column">
            <img
              src="../assets/首页_slices/图层 16.png"
              alt=""
              style="height: 259px; width: 470px"
            />
            <div></div>
            <img
              src="../assets/首页_slices/图层 17.png"
              alt=""
              style="height: 259px; width: 470px; margin-top: 30px"
            />
          </div>
          <!-- left -->
          <div>
            <div style="height: 259px; width: 470px">
              <img
                src="../assets/首页_slices/日用雑貨・食品・サプリメント等の輸出販売.png"
                alt=""
                style="margin-left: 110px; margin-top: 30px"
              />
              <img
                src="../assets/首页_slices/日本の日用雑貨や食品・サプリメント等を、国外の商社へ販売する事業を行っております。 当社とのお取引を検討されている商社・メーカ.png"
                alt=""
                style="margin-left: 110px; width: 550px; margin-top: 30px"
              />
            </div>
            <div>
              <B style="color: #286ff1; margin-left: 110px; font-weight: 600"
                >______________________________________________________________</B
              >
            </div>
            <div style="height: 259px; width: 470px">
              <img
                src="../assets/首页_slices//香港市場向け 医薬品と健康食品の越境EC.png"
                alt=""
                style="margin-left: 110px; margin-top: 60px"
              />
              <img
                src="../assets/首页_slices/オンライン販売チームを活用し、香港市場向けにOTC医薬品と健康食品をEC販売しております。 OEMやODMで市場の拡大と販売網.png"
                alt=""
                style="margin-left: 110px; width: 550px; margin-top: 30px"
              />
            </div>
          </div>
        </div>
        <div
          style="
            width: 580px;
            height: 770px;
            background: #eef2f6;
            position: absolute;
            left: 0;
            top: 1790px;
            z-index: -999;
          "
        >
          <img
            src="../assets/首页_slices/事業内容@3x.png"
            alt=""
            style="
              width: 100px;
              height: 23px;
              margin-left: 350px;
              margin-top: 70px;
            "
          />
          <img
            src="../assets/首页_slices/Business.png"
            alt=""
            style="width: 80px; height: 9px; margin-left: 20px"
          />
          <div style="margin-top: 10px; margin-left: 350px"><B>____</B></div>
        </div>
      </div>
      <!-- 求人募捐 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1200px;
          "
        ></div>

        <div
          style="
            width: 1200px;

            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 145px;
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/首页_slices/矩形 5 拷贝 7.png"
            alt=""
            style="width: 1200px; height:400px"
          />
        </div>
      </div>
      <!-- 求人募捐 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
          "
        ></div>

        <div
          style="
            width: 100%;

            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 75px;
            /* border:1px solid red */
          "
        >
          <img
            src="../assets/首页_slices/Contact.png"
            alt=""
            style="width: 100%; height: 400px"
          />
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 2">
      <!-- banner -->
      <div class="top-rowBanner1111"></div>

      <!-- 医院环境 -->
      <div style="display: flex; justify-content: center">
        <div
          style="
            display: flex;

            width: 1200px;

            height: 500px;
          "
        >
          <!-- left -->
          <div
            style="
              width: 70%;
              height: 500px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            "
          >
            <div
              style="
                padding-bottom: 15px;
                border-bottom: 2px dashed grey;
                width: 450px;
              "
            >
              会社名 <span style="margin-left: 120px">株式会社政軒</span>
            </div>
            <div
              style="
                padding-bottom: 15px;
                border-bottom: 2px dashed grey;
                width: 450px;
                display: flex;
                margin-top: 10px;
              "
            >
              所在地
              <span style="margin-left: 120px"
                ><img
                  src="../assets/日本官网-会社情報_slices/福岡市中央区春吉3丁目21－21 春野ビル5階E (5F E, Haruno Building, 3-21-21 Haruyo.png"
                  alt=""
                  style="width: 260px"
              /></span>
            </div>
            <div
              style="
                padding-bottom: 15px;
                border-bottom: 2px dashed grey;
                width: 450px;
                margin-top: 10px;
              "
            >
              代表理事 <span style="margin-left: 100px">李 杭（り こう）</span>
            </div>
            <div
              style="
                padding-bottom: 15px;
                border-bottom: 2px dashed grey;
                width: 450px;
                margin-top: 10px;
              "
            >
              法人等番号 <span style="margin-left: 82px">3290001103398</span>
            </div>
          </div>
          <!-- right -->
          <div
            style="
              width: 30%;
              height: 500px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              src="../assets/日本官网-会社情報_slices/图层 5.png"
              alt=""
              style="width: 200px"
            />
          </div>
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 3">
      <!-- banner -->
      <div class="top-rowBanner222222"></div>
      <!-- 关于博爱 -->

      <!-- 四大优势 -->

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          padding: 100px 0;
        "
      >
        <!-- left -->
        <div
          style="
            width: 1200px;
            height: 259px;
            display: flex;
            justify-content:space-between
          
            border:1px solid red
          "
        >
          <!-- right -->
          <div>
            <div>
              <img
                src="../assets/日本官网-事業内容_slices/日用雑貨・食品・サプリメント等の輸出販売.png"
                alt=""
                style="width: 375px; height: 17px"
              />
              <!-- <img src="../assets/首页_slices/Company Profile.png" alt="" style="margin-left:20px;height:13px"> -->
            </div>
            <!-- <div style="margin-top:20px"><B>____</B></div> -->
            <div>
              <img
                src="../assets/日本官网-事業内容_slices/日本の日用雑貨や食品・サプリメント等を、国外の商社へ販売する事業を行っております。 当社とのお取引を検討されている商社・メーカ@3x.png"
                alt=""
                style="margin-top: 40px; height: 155px; width: 500px"
              />
            </div>
          </div>
          <!-- left -->
          <div>
            <img
              src="../assets/日本官网-事業内容_slices/图层 6.png"
              alt=""
              style="width: 400px; height: 500px"
            />
          </div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          height: 100px;
          background: #eef2f6;
          margin-top: 39.6px;
          border-top: 1px solid #eef2f6;
          display: flex;
          align-items: center;
        "
      >
        <img
          src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
          alt=""
          style="margin-left: 336px; height: 18px"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;

            flex-direction: column;
            width: 1200px;

            margin-top: 90px;
          "
        >
          <div>
            <img
              src="../assets/日本官网-事業内容_slices/香港市場向け 医薬品と健康食品の越境EC@2x.png"
              alt=""
              style="width: 350px"
            />
          </div>
          <div>
            <img
              src="../assets/日本官网-事業内容_slices/オンライン販売チームを活用し、香港市場向けにOTC医薬品と健康食品をEC販売しております。 OEMやODMで市場の拡大と販売網.png"
              alt=""
              style="width: 1200px; height: 66px; margin-top: 30px"
            />
          </div>
          <div>
            <img
              src="../assets/日本官网-事業内容_slices/图层 7.png"
              alt=""
              style="width: 1200px; height:380px; margin-top: 60px"
            />
          </div>
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 130px;
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 4">
      <div class="top-rowBanner444444"></div>
      <!-- 关于我们导航栏 公司概况 品质服务 企业荣誉 企业文化 -->
      <div style="display: flex; justify-content: center; align-items: center">
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 1200px;

            height: 400px;
          "
        >
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
            "
          >
            <div
              style="
                border-bottom: 1px solid grey;
                width: 120px;
                margin-left: 200px;
                display: flex;
                justify-content: center;
                height: 35px;
              "
            >
              雇用形態
            </div>
            <div style="margin-left: 260px">
              <input
                type="checkbox"
                id="option1"
                value="Option1"
                v-model="selectedOption"
              />
              <label for="option1" style="margin-left: 6px">正社員</label>

              <input
                type="checkbox"
                id="option2"
                value="Option2"
                v-model="selectedOption"
                style="margin-left: 40px"
              />
              <label for="option2" style="margin-left: 6px"
                >アルバイト・パート</label
              >
            </div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
            "
          >
            <div
              style="
                border-bottom: 1px solid grey;
                width: 120px;
                margin-left: 200px;
                display: flex;
                justify-content: center;
                height: 83px;
              "
            >
              職種
            </div>
            <div
              style="
                margin-left: 260px;
                display: flex;
                flex-direction: column;
                align-items: start;
              "
            >
              <div>
                <input
                  type="checkbox"
                  id="option1"
                  value="Option1"
                  v-model="selectedOption"
                />
                <label for="option1" style="margin-left: 6px">薬剤師</label>
              </div>

              <div style="margin-top: 20px">
                <input
                  type="checkbox"
                  id="option2"
                  value="Option2"
                  v-model="selectedOption"
                />
                <label for="option2" style="margin-left: 6px">登録管理者</label>
              </div>
            </div>
          </div>
          <el-button
            type="primary"
            style="
              width: 110px;
              height: 35px;
              font-size: 16px;
              border-radius: 0;
              margin-top: 35px;
              margin-left: 330px;
            "
            >申 請</el-button
          >
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.itemIndex == 5">
      <!-- banner -->
      <div class="top-rowBanner555555"></div>
      <!-- 关于我们导航栏 公司概况 品质服务 企业荣誉 企业文化 -->
      <div style="display:flex;justify-content:center;align-items:center;padding:60px 0">
        <div>お問い合わせ</div>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
         
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1200px;
           border:1px dashed grey;
           padding:170px 0;
            height: 400px;
          "
        >
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
              "
            >
              名前（姓名）
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
            
              "
            >
            フリガナ（セイメイ）
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
             
                display: flex;
                justify-content: center;
                align-items: center;
              
              
              "
            >
              
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
              "
            >
            会社名
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
              "
            >
            お電話番号
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
              "
            >
            メールアドレス
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
              border-bottom: 1px dashed grey;
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
              "
            >
            ご希望の連絡方法
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
               
                display: flex;
                justify-content: center;
                align-items: center;
                
              "
            >
              
            </div>
     <div style="width:340px;display:flex;justify-content:space-between">
      <div
              style="
                width: 160px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
                line-height:30px
              "
            >
            <input
            style=" margin-left:18px"
                type="radio"
                id="option1"
                value="Option1"
                v-model="selectedOption1"
              />
              <label for="option1" style="margin-left: 6px">メール</label>
          </div>
          <div
              style="
                width: 160px;
                height: 30px;
                border: 1px dashed grey;
                background: #eef2f6;
                line-height:30px;
               
              "
            >
            <input
            style=" margin-left:18px"
                type="radio"
                id="option1"
                value="Option1"
                v-model="selectedOption1"
              />
              <label for="option1" style="margin-left: 6px">電話</label>
          </div>
     </div>
     <div></div>
            <div></div>
          </div>
          <div
            style="
              width: 1200px;
         
              margin-top: 30px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div></div>
            <div></div>
            <div
              style="
                width: 160px;
                display: flex;
                justify-content:start;
                height: 25px;
              "
            >
            お問い合わせ内容
            </div>
            <div
              style="
                width: 45px;
                height: 25px;
                background: #cf131c;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                border: 1px dashed black;
              "
            >
              必须
            </div>
            <div
              style="
                width: 340px;
                height: 130px;
                border: 1px dashed grey;
                background: #eef2f6;
              "
            ></div>
            <div></div>
            <div></div>
          
          </div>
          <div style="width:130px;background:#cf131c;padding:10px 0;color:white;display:flex;justify-content:center;margin-left:180px">送信</div>
        </div>
      </div>
      <!-- footer -->
      <div
        style="
          width: 100%;
          height: 300px;
          background: #eef2f6;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top:100px
        "
      >
        <div
          style="
            width: 1200px;
            height: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <img
              src="../assets/首页_slices/logo.png"
              alt=""
              style="width: 220px"
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <img
              src="../assets/首页_slices/会社情報 事業内容 採用情報 お問い合わせ.png"
              alt=""
            />
          </div>
          <div style="border-left: 1px dashed grey; padding-left: 55px">
            <div>
              <img
                src="../assets/首页_slices/株式会社政轩.png"
                alt=""
                style="height: 25px"
              />
              <img
                src="../assets/首页_slices/Sei Ken Co,Ltd．.png"
                alt=""
                style="height: 16px; margin-left: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/福岡県福岡市中央区春吉３丁目21−21春野ビル５階E.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
            <div>
              <img
                src="../assets/首页_slices/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.png"
                alt=""
                style="margin-top: 10px"
              />
            </div>
          </div>
        </div>
        
      </div>
    </div>
  
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption1: "",
      selectedOption: "",
      showtable: 1,
      itemIndex: 1,
      itemIndexAbout: 1,
      itemIndexVip: 1,
      itemIndexba: 1,
      itemIndexSup: 1,
      itemIndexzp: 1,
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
    };
  },

  methods: {
    btnshowtable(index) {
      this.showtable = index;
    },
    btnClick(index) {
      this.itemIndex = index;
    },
    btnClickVip(index) {
      this.itemIndexVip = index;
    },
    btnClickba(index) {
      this.itemIndexba = index;
    },
    btnClickAbout(index) {
      this.itemIndexAbout = index;
    },
    btnClickSup(index) {
      this.itemIndexSup = index;
    },
    btnClickzp(index) {
      this.itemIndexzp = index;
    },
  },
};
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
.nav {
  width: 1200px;
  height: 80px;
  /* background-color: rgb(159, 81, 81); */
  color: black;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.banner {
  height: 80px;
  background-color: rgb(245, 228, 228);
  color: black;
  display: flex;
  justify-content: space-between;
}
.center {
  list-style: none;

  /* background-color: pink; */
}
li {
  color: rgb(24, 5, 5);
  float: left;
}
a:hover {
  /* background-color: violet; */
  color: #d0161f;
  text-decoration: underline;
}
a {
  /* 
        一定注意要把a转成行内块元素，
        如果转的是块元素那么短竖线会掉下去，
        因为块级元素是独占一行的
    */
  display: inline-block;
  padding: 0 25px;
  line-height: 80px;
  text-decoration: none;
  color: black;
}

.top-rowBanner {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/首页_slices/banner.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner1111 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/日本官网-会社情報_slices/会 社 情 報.png")
    no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner222222 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/banner1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner333333 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/banner1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner444444 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/日本官网-招聘_slices/1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner555555 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/日本官网-联系_slices/2.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 440px;
}
.top-rowBanner666 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/cjx.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 260px;
}
.top-rowBanner6666 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/join.jpg") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
}
.top-rowBanner1 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/size.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  margin-top: 35px;
}
.top-rowBanner2 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/indexAbout.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBannerAbout {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/1.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 100px;
  /* margin-top:35px; */
}
.top-rowBanner2222 {
  background: #f8f8f8;
  /* padding: 3em 0 4em 0; */
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: white no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 80px;
  border-bottom: 3px dotted grey;

  /* margin-top:35px; */
}
.top-rowBanner3 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/map.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 220px;
  /* margin-top:35px; */
}
.top-rowBanner5 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/bannerVip.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner5555 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/supbanner.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner6 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/join.jpg") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.top-rowBanner544444 {
  background: #f8f8f8;
  padding: 3em 0 4em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/badsj.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.togethter {
  background: #f8f8f8;
  padding: 1em 0 1em 0;
  /* border-top:1px solid #f1efef; */
  /* border-bottom:1px solid #f1efef; */
  background: url("../assets/web/toge.png") no-repeat 0px 0px;
  background-size: 100% 100%;
  height: 540px;
  /* margin-top:35px; */
}
.active {
  color: #d0161f;
  text-decoration: underline;
}
.activeShowHos {
  background: #0077c3;
  color: white;
  padding: 10px;
  /* text-decoration: underline; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
}
.activeAbout {
  color: #d0161f;
  text-decoration: underline;
}
</style>